import { makeStyles } from "@material-ui/core";
import MuiButton from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";
import PermissionsCheck from "../../PermissionCheck";
const useStyles = makeStyles({
    progress: {
        position: "absolute",
    },
    childrenHidden: {
        visibility: "hidden",
    },
});
export default function Button(props) {
    const classes = useStyles();
    const { loading, permission, groupId, shouldHideChildren, children, ...rest } = props;
    const BaseButton = (React.createElement(MuiButton, { ...rest }, loading ? (React.createElement(React.Fragment, null,
        React.createElement(CircularProgress, { "data-cy": "ui-button-loading", className: classes.progress, color: "inherit", size: 24 }),
        React.createElement("span", { className: classes.childrenHidden }, children))) : (children)));
    if (permission) {
        return (React.createElement(PermissionsCheck, { permission: permission, groupId: groupId, shouldHideChildren: shouldHideChildren }, BaseButton));
    }
    return BaseButton;
}
Button.defaultProps = {
    color: "primary",
    variant: "contained",
    disableElevation: true,
};
//# sourceMappingURL=index.js.map